// src/components/ProjectDetail/ProjectDetail.js
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, ExternalLink, Download, Globe } from 'lucide-react';
import './ProjectDetails.css';

const ProjectDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(0);

  // This would typically come from an API or context
  const projects = {
    1: {
  title: 'Vidya Global School App',
  description: 'A full-featured ERP based LMS application to manage student records, results, attendance, syllabus, gallery, announcements, and messaging.',
  longDescription: 'Vidya Global School App is a comprehensive Learning Management System (LMS) and Enterprise Resource Planning (ERP) solution designed specifically for modern educational institutions. The application streamlines school operations by providing real-time access to academic information, automating administrative tasks, and enhancing communication between parents, students, and teachers. With intuitive dashboards for all stakeholders, the app delivers actionable insights through advanced analytics and enables seamless digital transformation for educational institutions.',
  image: '/images/VGSPreview.png',
  screenshots: [
    '/images/VGSPreview.png',
    '/images/VGS1.png',
    '/images/VGS2.png',
    '/images/VGS3.png',
    '/images/VGS4.png',
    '/images/VGS5.png',
    '/images/VGS6.png',
  ],
  techStack: [
    { name: 'React Native', color: '#61DAFB' },
    { name: 'JavaScript', color: '#3178C6' },
    { name: 'Redux Toolkit', color: '#764ABC' },
    { name: 'Firebase', color: '#339933' },
    { name: 'Encryption', color: '#47A248' },
    { name: 'SQLite Storage', color: '#000000' },
    { name: 'JWT Token', color: '#010101' },
    
  ],
  platforms: {
    playStore: 'https://play.google.com/store/apps/details?id=com.sits.vgs',
    appStore: 'https://apps.apple.com/in/app/vgs/id1616140930',
    apk: '',
    website: '',
  },
  features: [
    'Student Results Management & Report Cards',
    'Real-time Attendance Tracking & Analytics',
    'Academic Syllabus & Timetable Access',
    'Notice Board & School Announcements',
    'Secure Parent-Teacher Messaging System',
    'Photo Gallery & Event Management',
    'Fee Structure & Payment Status',
    'Homework & Assignment Submissions'
  ],
  role: 'Lead React Native Developer',
  duration: '6 Months',
  teamSize: '4 Members'
},
2: {
  title: 'SwiftCRM – CRM App',
  description: 'A full-featured CRM application to manage leads, deals, pipelines, tasks, and analytics with modern UI/UX.',
  longDescription: 'SwiftCRM is an enterprise-grade Customer Relationship Management solution built for modern sales teams and businesses. This comprehensive mobile application streamlines the entire sales lifecycle from lead generation to deal closure, providing real-time insights and collaboration tools. Built with React Native, the app offers cross-platform functionality with native-like performance on both iOS and Android devices. The platform features intelligent automation, customizable pipelines, and advanced analytics that empower sales teams to make data-driven decisions and maximize revenue opportunities.',
  image: '/images/SwiftCRMPreview.png',
  screenshots: [
    '/images/SwiftCRMPreview.png',
    '/images/SwiftCrm1.png',
    '/images/SwiftCrm2.png',
    '/images/SwiftCrm3.png',
    '/images/SwiftCrm4.png',
    '/images/SwiftCrm5.png',
    '/images/SwiftCrm6.png',
  ],
  techStack: [
    { name: 'React Native', color: '#61DAFB' },
    { name: 'TypeScript', color: '#3178C6' },
    { name: 'Redux Toolkit', color: '#764ABC' },
    { name: 'Firebase', color: '#FFCA28' },
    { name: 'Node.js', color: '#339933' },
    { name: 'MongoDB', color: '#47A248' },
    { name: 'Socket.io', color: '#010101' },
    { name: 'AWS S3', color: '#FF9900' }
  ],
  platforms: {
    playStore: '', // Leave empty if not on Play Store
    appStore: '',  // Leave empty if not on App Store
    apk: '/apk/SwiftCRM.apk', // Path to APK in public folder
    website: '', // Add website if exists
  },
  features: [
    'Lead Management & Scoring System',
    'Deal Pipeline with Custom Stages',
    'Real-time Team Collaboration',
    'Task & Activity Tracking',
    'Advanced Analytics Dashboard',
    'Document & File Management',
    'Email Integration & Automation',
    'Performance Reporting & Insights',
    'Mobile Offline Support',
    'Push Notifications & Alerts'
  ],
  role: 'Lead React Native Developer & Project Architect',
  duration: '8 Months',
  teamSize: '5 Members',
  // Optional: Add project metrics
  metrics: {
    users: '500+',
    dealsProcessed: '10,000+',
    responseTime: '< 2s',
    uptime: '99.9%'
  }
},
 3: {
      title: 'Lurnexa App',
     description: 'A comprehensive Learning Management System with courses, quizzes, assignments, progress tracking, and certification - similar to Udemy.',
  longDescription: 'Lurnexa LMS is an enterprise-grade Learning Management System designed to revolutionize digital education. This comprehensive platform provides institutions, educators, and learners with a seamless ecosystem for creating, delivering, and managing online courses. Built with React Native, the application offers native performance across both Android and iOS devices while supporting features like video streaming, interactive assessments, progress analytics, and certificate generation. The platform has been successfully deployed across multiple educational institutions, serving thousands of students with a 95% satisfaction rate and significantly improving learning outcomes through data-driven insights.',
      image: '/images/LurnexaLMSPreview.png',
      screenshots: [
         '/images/LurnexaLMSPreview.png',
   
    '/images/Lurnexa4.png',
    // '/images/Lurnexa5.png',
    '/images/Lurnexa6.png',
     '/images/Lurnexa7.png',
    '/images/Lurnexa8.png',
    // '/images/Lurnexa9.png',
    
    '/images/Lurnexa11.png',
    
      ],
      techStack: [
    { name: 'React Native', color: '#61DAFB' },
    { name: 'JavaScript', color: '#3178C6' },
    { name: 'Redux Toolkit', color: '#764ABC' },
    { name: 'Node.js', color: '#339933' },
    { name: 'MongoDB', color: '#47A248' },
    { name: 'Firebase', color: '#FFCA28' },
    { name: 'AWS S3', color: '#FF9900' },
    { name: 'Socket.io', color: '#010101' },
    { name: 'JWT Authentication', color: '#EC4899' },
  ],
      platforms: {
        playStore: '',
        appStore: '',
        apk: '/apk/LurnexaLMS.apk',
        website: '',
      },
     features: [
    'Interactive Course Catalog',
    'Quizzes & Assessments with Instant Grading',
    'Assignment Submission & Automated Evaluation',
    'Progress Tracking & Performance Analytics',
    'Certificate Generation upon Course Completion',
    'Discussion Forums & Peer-to-Peer Learning',
    'Download Courses for Offline Access',
    'Instructor Dashboard with Course Analytics',
    'Payment Gateway for Premium Content',
    'Push Notifications for Deadlines & Updates',
    'Bookmark & Save for Later Feature',
    'Live Class Integration',
  ],
      role: 'Lead Developer',
      duration: 'Ongoing',
      teamSize: '1 Members'
    },
    4: {
      title: 'E-Commerce Mobile App',
      description: 'A scalable e-commerce app with cart, checkout, payment gateway, order tracking, and admin dashboard.',
      longDescription: 'This e-commerce solution provides a seamless shopping experience across all devices. Features include personalized recommendations, secure payment processing, real-time inventory management, and comprehensive admin controls.',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
      screenshots: [
          '/images/Ecom1.png',
          '/images/Ecom2.png',
          '/images/Ecom3.png',
          '/images/Ecom4.png',
          '/images/Ecom5.png',
        ],
      techStack: [
        { name: 'React Native', color: '#61DAFB' },
         { name: 'JavaScript', color: '#3178C6' },
        { name: 'Firebase', color: '#FFCA28' },
        { name: 'SQLite', color: '#6772E5' },
        { name: 'Redux Toolkit', color: '#764ABC' }
      ],
      platforms: {
        playStore: 'https://play.google.com/store/apps/details?id=com.way4mall',
        appStore: '',
        apk: '',
        website: '',
      },
      features: [
        'Secure Payments',
        'Order Tracking',
        'Wishlist & Favorites',
        'Push Notifications'
      ],
      role: 'React Native Developer',
      duration: '4 Months',
      teamSize: '3 Members'
    },
    5: {
  title: 'Way4Recharge – Utility & Recharge App',
  description:
    'Recharge and utility payment app supporting mobile, DTH, and bill payments with real-time transaction updates.',
  longDescription:
    'Way4Recharge is a utility and digital recharge application designed to simplify everyday payments. Users can perform mobile recharges, DTH recharges, and utility bill payments with real-time transaction tracking and secure payment processing.',
  image: '/images/Way4RechargePreview.png',
  screenshots: [
    '/images/Way4RechargePreview.png',
    '/images/Way4Recharge1.jpg',
    '/images/Way4Recharge2.jpg',
    '/images/Way4Recharge3.jpg',
    '/images/Way4Recharge5.jpg',
    '/images/Way4Recharge6.jpg'
  ],
  techStack: [
    { name: 'React Native', color: '#61DAFB' },
    { name: 'REST APIs', color: '#0EA5E9' },
    { name: 'Secure Payments', color: '#16A34A' },
     { name: 'Firebase', color: '#FFCA28' },
        { name: 'Redux Toolkit', color: '#764ABC' }
  ],
  platforms: {
    playStore: 'https://play.google.com/store/apps/details?id=com.way4recharge',
    appStore: '',
    apk: '',
    website: ''
  },
  features: [
    'Mobile & DTH Recharge',
    'Utility Bill Payments',
    'Real-time Transaction Status',
    'Secure Payment Flow'
  ],
  role: 'React Native Developer',
      duration: '4 Months',
      teamSize: '2 Members'
},

6: {
  title: 'SBSC – ERP & Institutional App',
  description:
    'Enterprise ERP application for managing academic workflows, administration, and institutional operations.',
  longDescription:
    'SBSC is a robust ERP solution designed for educational institutions to manage academics, administration, and staff operations. The app provides role-based dashboards for students, faculty, and administrators.',
  image:    '/Images/SBSCLogo.png',
  screenshots: [
 '/Images/SBSCLogo.png',
    '/Images/SBSC1.webp',
  ],
  techStack: [
    { name: 'React Native', color: '#61DAFB' },
    { name: 'TypeScript', color: '#3178C6' },
    { name: 'Secure APIs', color: '#16A34A' },
          { name: 'Firebase', color: '#FFCA28' },
        { name: 'SQLite', color: '#6772E5' },
        { name: 'Redux Toolkit', color: '#764ABC' }
  ],
  platforms: {
    playStore:
      'https://play.google.com/store/apps/details?id=com.sits.sitsliveerpsbsc',
    appStore: 'https://apps.apple.com/in/app/sbsc/id6453025645',
    apk: '',
    website: ''
  },
  features: [
    'Role-Based Access Control',
    'Academic & Administrative Management',
    'Staff & Student Dashboards'
  ],
    role: 'React Native Developer',
      duration: '4 Months',
      teamSize: '2 Members'
},

7: {
  title: 'Rayhope Global – e-Commerce App',
  description:
    'Rayhope Global is a cutting-edge e-commerce application designed to bring the best of online shopping to your fingertips.',
  longDescription:
    'Rayhope Global offers a seamless, secure, and rewarding shopping experience for customers across the globe. Whether you are looking for the latest fashion trends, essential electronics, beauty products, wellness items, or home essentials',
  image: '/Images/RayhopePreview.png',
  screenshots: [
    '/Images/RayhopePreview.png',
    '/Images/Rayhope1.png',
    '/Images/Rayhope2.png',
     '/Images/Rayhope3.png',
    '/Images/Rayhope4.png',
     '/Images/Rayhope5.png',
  ],
  techStack: [
    { name: 'React Native', color: '#61DAFB' },
    { name: 'JavaScript', color: '#F7DF1E' },
    { name: 'REST APIs', color: '#0EA5E9' }
  ],
  platforms: {
    playStore:
     'https://play.google.com/store/apps/details?id=com.rayhope',
    appStore: '',
    apk: '',
    website: ''
  },
  features: [
    'Secure Payments',
        'Order Tracking',
        'Wishlist & Favorites',
        'Push Notifications'
  ],
   role: 'React Native Developer',
      duration: '3 Months',
      teamSize: '2 Members'
},

8: {
  title: 'Glowoman – Salon Booking Platform',
  description:
    'Service booking platform enabling users to browse services, book appointments, and manage schedules.',
  longDescription:
    'Glowoman is a web-based salon booking platform that allows users to browse services, book appointments, and manage schedules through an intuitive and responsive UI.',
  image: '/Images/GlowomanPreview.png',
  screenshots: ['/Images/GlowomanPreview.png',
    '/Images/GlowomanWeb.png'
  ],
  techStack: [
    { name: 'React.js', color: '#61DAFB' },
    { name: 'REST APIs', color: '#0EA5E9' },
     { name: 'React Native', color: '#61DAFB' },
    { name: 'JavaScript', color: '#F7DF1E' },
  ],
  platforms: {
    website: 'https://www.glowoman.in',
    playStore: 'https://play.google.com/store/apps/details?id=user.Glowoman'
  },
  features: [
    'Service Booking',
    'Appointment Scheduling',
    'Responsive Web UI',
    'User Management'
  ],
  role: 'React Developer',
      duration: '4 Months',
      teamSize: '3 Members'
},

9: {
  title: 'Beds & Divans – E-commerce Website',
  description:
    'Furniture e-commerce website with product listings, filtering, and SEO-optimized UI.',
  longDescription:
    'Beds & Divans is a furniture e-commerce platform focused on performance, SEO optimization, and user-friendly navigation. It enables customers to explore products with advanced filtering and a smooth shopping experience.',
  image: '/Images/BedsDivanPreview.png',
  screenshots: ['/Images/BedsDivanPreview.png',
    '/Images/BedsDivan1.png'
  ],
  techStack: [
    { name: 'React.js', color: '#61DAFB' },
    { name: 'SEO Optimization', color: '#22C55E' },
    { name: 'Responsive Design', color: '#0EA5E9' }
  ],
  platforms: {
    website: 'https://bedsdivans.co.uk'
  },
  features: [
    'Product Listings',
    'Category & Price Filtering',
    'SEO-Friendly Architecture'
  ],
    role: 'React Developer',
      duration: '4 Months',
      teamSize: '3 Members'
},

10: {
  title: 'Daylyy – Social media Platform',
  description:
    'Social media platform used to be where you shared your day.',
  longDescription:
    `Daylyy brings back what got lost. No algorithms deciding what matters. No pressure to perform. No wondering if what you’re seeing is real.Just daily pictures from people you actually know. In a world full of AI-generated content, filters, and fake perfection, Daylyy is intentionally human.
Why Daylyy is different:
• Human-only: no AI-generated content
• Daily Posts: simple, casual, pressure-free
• Friends first: see people you care about, not strangers
• No performance: no likes to chase, no audience to impress

Daylyy gives you a place where you don’t have to overthink.
Post your day. See your friends again. Feel connected.
Welcome back to social media.`,
  image: '/Images/DayllyPreview.png',
  screenshots: ['/Images/DayllyPreview.png',
    '/Images/Daylly1.png',
  ],
  techStack: [
    { name: 'React.js', color: '#61DAFB' },
    { name: 'REST APIs', color: '#0EA5E9' },
     { name: 'React Native', color: '#61DAFB' },
    { name: 'JavaScript', color: '#F7DF1E' },
  ],
  platforms: {
    website: 'https://www.daylyy.com',
    playStore:'https://play.google.com/store/apps/details?id=com.e7cfe54e3221.app',
     appStore: 'https://apps.apple.com/in/app/daylyy/id1589314639',
  },
  features: [
    'Service Showcase',
    'Responsive UI',
    'Modern Web Design'
  ],
   role: 'React & React Native Developer',
      duration: '4 Months',
      teamSize: '3 Members'
},

11: {
  title: 'Alba Cars – Automotive Website',
  description:
    'Corporate website for an automotive business with vehicle listings and lead generation.',
  longDescription:
    'Alba Cars is an automotive business website designed to display vehicle listings, capture leads, and provide a professional digital presence for the brand.',
  image: '/Images/AlbaCars1.png',
  screenshots: ['/Images/AlbaCars1.png',
    '/Images/AlbaCars2.png',
    '/Images/AlbaCars3.png'
  ],
  techStack: [
    { name: 'React.js', color: '#61DAFB' },
    { name: 'Responsive Design', color: '#0EA5E9' }
  ],
  platforms: {
    website: 'https://albacars.ae'
  },
  features: [
    'Vehicle Listings',
    'Lead Generation Forms',
    'Mobile-Friendly UI'
  ],
  role: 'React Developer',
      duration: '4 Months',
      teamSize: '3 Members'
},

// 12: {
//   title: 'EbaTech – Admin Management System',
//   description:
//     'Admin dashboard for managing business services, configurations, and operations.',
//   longDescription:
//     'EbaTech is an admin management system built to handle configurations, services, and operational workflows through a centralized and user-friendly dashboard.',
//   image: '/images/EbaTechPreview.png',
//   screenshots: ['/images/EbaTech1.png'],
//   techStack: [
//     { name: 'React.js', color: '#61DAFB' },
//     { name: 'Material UI', color: '#007FFF' },
//     { name: 'REST APIs', color: '#0EA5E9' }
//   ],
//   platforms: {
//     website: 'https://ebatechnology.netlify.app'
//   },
//   features: [
//     'Admin Dashboard',
//     'Configuration Management',
//     'Operational Controls'
//   ]
// },

// 13: {
//   title: 'Victor India – Business Utility App',
//   description:
//     'Business utility mobile app providing services, content management, and customer interaction features.',
//   longDescription:
//     'Victor India is a business-focused mobile application designed to manage services, publish content, and engage customers through a streamlined digital platform.',
//   image: '/images/VictorPreview.png',
//   screenshots: [
//     '/images/Victor1.png',
//     '/images/Victor2.png'
//   ],
//   techStack: [
//     { name: 'React Native', color: '#61DAFB' },
//     { name: 'JavaScript', color: '#F7DF1E' },
//     { name: 'REST APIs', color: '#0EA5E9' }
//   ],
//   platforms: {
//     playStore:
//       'https://play.google.com/store/apps/details?id=com.victorindia',
//     appStore: '',
//     apk: '',
//     website: ''
//   },
//   features: [
//     'Business Services Management',
//     'Content Publishing',
//     'Customer Engagement Tools'
//   ]
// },
  };

  const project = projects[id];

   // Fixed back button handler
  const handleBackClick = () => {
    // Navigate to home page
    navigate('/');
    
    // Scroll to projects section after a short delay
    setTimeout(() => {
      const projectsSection = document.getElementById('projects');
      if (projectsSection) {
        window.scrollTo({
          top: projectsSection.offsetTop - 80,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  if (!project) {
    return (
      <div className="project-not-found">
        <h2>Project not found</h2>
        <button onClick={handleBackClick}>Back to Projects</button>
      </div>
    );
  }

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % project.screenshots.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + project.screenshots.length) % project.screenshots.length);
  };

  return (
    <motion.div 
      className="project-detail"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="container">
        <button className="back-button" onClick={handleBackClick}>
          <ChevronLeft size={20} />
          Back to Projects
        </button>

        <div className="project-header">
          <motion.h1 
            className="project-title"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            {project.title}
          </motion.h1>
          <motion.p 
            className="project-subtitle"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            {project.description}
          </motion.p>
        </div>

        <div className="project-layout">
          {/* Left Column - Carousel */}
          <div className="project-carousel-section">
            <div className="carousel-container">
              <div className="carousel-main">
                <button className="carousel-nav prev" onClick={prevImage}>
                  <ChevronLeft size={24} />
                </button>
                
                <AnimatePresence mode="wait">
                  <motion.img
                    key={currentImage}
                    src={project.screenshots[currentImage]}
                    alt={`${project.title} screenshot ${currentImage + 1}`}
                    className="carousel-image"
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={{ duration: 0.3 }}
                  />
                </AnimatePresence>

                <button className="carousel-nav next" onClick={nextImage}>
                  <ChevronRight size={24} />
                </button>
              </div>
              
              <div className="carousel-thumbnails">
                {project.screenshots.map((img, index) => (
                  <button
                    key={index}
                    className={`thumbnail ${index === currentImage ? 'active' : ''}`}
                    onClick={() => setCurrentImage(index)}
                  >
                    <img src={img} alt={`Thumbnail ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column - Details */}
          <div className="project-details-section">
            <motion.div 
              className="details-card"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              <h3 className="details-title">Project Details</h3>
              
              <div className="project-meta">
                <div className="meta-item">
                  <span className="meta-label">Role</span>
                  <span className="meta-value">{project.role}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-label">Duration</span>
                  <span className="meta-value">{project.duration}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-label">Team Size</span>
                  <span className="meta-value">{project.teamSize}</span>
                </div>
              </div>

              <div className="project-description-long">
                <h4>Overview</h4>
                <p>{project.longDescription}</p>
              </div>

              <div className="project-features">
                <h4>Key Features</h4>
                <ul className="features-list">
                  {project.features.map((feature, index) => (
                    <motion.li 
                      key={index}
                      initial={{ x: -20, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ delay: 0.5 + index * 0.1 }}
                    >
                      <span className="feature-bullet">✓</span>
                      {feature}
                    </motion.li>
                  ))}
                </ul>
              </div>

              <div className="tech-stack-section">
                <h4>Technology Stack</h4>
                <div className="tech-stack-grid">
                  {project.techStack.map((tech, index) => (
                    <span 
                      key={index}
                      className="tech-stack-item"
                      style={{ '--tech-color': tech.color }}
                    >
                      {tech.name}
                    </span>
                  ))}
                </div>
              </div>

              <div className="project-actions">
                <h4>Available On</h4>
                <div className="platform-buttons">
                  {project.platforms.playStore && (
                    <a 
                      href={project.platforms.playStore} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="platform-btn play-store"
                    >
                      <ExternalLink size={18} />
                      <span>Google Play Store</span>
                    </a>
                  )}
                  
                  {project.platforms.appStore && (
                    <a 
                      href={project.platforms.appStore} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="platform-btn app-store"
                    >
                      <ExternalLink size={18} />
                      <span>Apple App Store</span>
                    </a>
                  )}
                  
                  {project.platforms.apk && (
                    <a 
                      href={project.platforms.apk} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="platform-btn apk"
                    >
                      <Download size={18} />
                      <span>Download APK</span>
                    </a>
                  )}
                  
                  {project.platforms.website && (
                    <a 
                      href={project.platforms.website} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="platform-btn website"
                    >
                      <Globe size={18} />
                      <span>Visit Website</span>
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectDetail;